const DASHBOARD_PREFIX_LOCALSTORAGE_KEY = process.env.REACT_APP_DASHBOARD_PREFIX_LOCALSTORAGE_KEY || 'dashboard';

export const getStoredDashboard = (id) => {
    const data = window.localStorage.getItem(`${DASHBOARD_PREFIX_LOCALSTORAGE_KEY}-${id}`);
    return data ? JSON.parse(data) : null;
};

export const setStoredDashboard = (id, data) => {
    window.localStorage.setItem(`${DASHBOARD_PREFIX_LOCALSTORAGE_KEY}-${id}`, JSON.stringify(data));
};

export const clearStoredDashboard = (id) => {
    window.localStorage.removeItem(`${DASHBOARD_PREFIX_LOCALSTORAGE_KEY}-${id}`);
};

const PENDING_MAIN_DASHBOARD_JOB_KEY = `${DASHBOARD_PREFIX_LOCALSTORAGE_KEY}-pending-main-job`;

export const setPendingMainDashboardJob = ({ job, company }) => {
    window.localStorage.setItem(
        PENDING_MAIN_DASHBOARD_JOB_KEY,
        JSON.stringify({ job, company: company ?? null }),
    );
};

export const consumePendingMainDashboardJob = () => {
    const raw = window.localStorage.getItem(PENDING_MAIN_DASHBOARD_JOB_KEY);
    if (!raw) return null;
    window.localStorage.removeItem(PENDING_MAIN_DASHBOARD_JOB_KEY);
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};
